import { JSX } from "react";
import { BasicRecord } from "./basicRecord";
import { BasicTable } from "./BasicTable";
import { SummaryResultNetworkType, SummaryResultType } from "./enumerations";

interface ByGeocodeProps {
  providersEndpointFunc: (networkType: SummaryResultNetworkType, resultType: SummaryResultType, key: string) => string;
  records: BasicRecord[];
}

const ByGeocode = (props: ByGeocodeProps): JSX.Element => (
  <BasicTable
    {...props}
    records={props.records}
    tableName="Geocode Result"
  />
);

export { ByGeocode };
